import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';
import { Role, User, UserRoleVM } from 'app/_models';

@Injectable({ providedIn: 'root' })
export class UserRolesService {
    rolesUrl: string = '';
    usersUrl: string = '';

    rolesDataSource = new BehaviorSubject<Role[]>([]);
    currentRoles: Observable<any>;

    usersDataSource = new BehaviorSubject<UserRoleVM[]>([]);
    currentUsers: Observable<any>;

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this.rolesUrl = baseUrl + 'api/Roles';
        this.usersUrl = baseUrl + 'api/UserRoles';

        this.getUsers();
        this.getRoles();
    }

    changeUserRoles(roles: Role[], users?: UserRoleVM[]) {
        this.rolesDataSource.next(roles);

        if (users) {
            this.usersDataSource.next(users);
        }
    }

    //#region - ROLES METHODS
    getRoles() {
        this.http.get<Role[]>(this.rolesUrl).subscribe((data: Role[]) => {
            this.rolesDataSource.next(data);
        });
    }

    getRoleById(id: number): Observable<Role> {
        return this.http.get<Role>(`${this.rolesUrl}/${id}`);
    }

    createRole(params: Role): Observable<Role> {
        return this.http.post<Role>(this.rolesUrl, params);
    }

    updateRole(id: number, role: Role) {
        return this.http.put(`${this.rolesUrl}/${id}`, role);
    }

    deleteRole(id: number): Observable<Role> {
        return this.http.delete<Role>(`${this.rolesUrl}/${id}`);
    }
    //#endregion

    //#region - USER METHODS
    getUsers() {
        this.http.get<UserRoleVM[]>(this.usersUrl).subscribe((data: UserRoleVM[]) => {
            this.usersDataSource.next(data);
        });
    }

    getSPUsers(): Observable<User[]> {
        return this.http.get<any[]>(this.usersUrl + '/spUserRoles');
    }

    getUserById(id: number): Observable<UserRoleVM> {
        return this.http.get<UserRoleVM>(`${this.usersUrl}/${id}`);
    }

    createUser(params: any): Observable<UserRoleVM> {
        return this.http.post<any>(this.usersUrl, params);
    }

    updateUser(id: Number, user: any): Observable<any> {
        return this.http.put(`${this.usersUrl}/${id}`, user);
    }

    deleteUser(id: number): Observable<User> {
        return this.http.delete<User>(`${this.usersUrl}/${id}`);
    }

    deleteMultipleUsers(users: UserRoleVM[]): Observable<any> {
        const url = `${this.usersUrl}/bulkdelete`;
        return this.http.post<any>(url, users);
    }
    //#endregion
}
